import { render } from "./TheHeader.vue?vue&type=template&id=af893dd6&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=af893dd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af893dd6"

export default script